
export const STAR_MAP_TEMPLATE_CATEGORIES = Object.freeze([
  {
    id:"world",
    labelKey:"mapCategoryWorld",
    shortLabelKey:"mapCategoryWorldShort"
  },
  {
    id:"country",
    labelKey:"mapCategoryCountry",
    shortLabelKey:"mapCategoryCountryShort"
  },
  {
    id:"region",
    labelKey:"mapCategoryRegion",
    shortLabelKey:"mapCategoryRegionShort"
  }
]);


export const STAR_MAP_TEMPLATES = Object.freeze([

{
 id:"world-classic",
 category:"world",
 nameKey:"worldClassicName",
 descriptionKey:"worldClassicDesc",
 image:"/assets/star-map-templates/world-classic.svg"
},

{
 id:"world-route",
 category:"world",
 nameKey:"worldRouteName",
 descriptionKey:"worldRouteDesc",
 image:"/assets/star-map-templates/world-route.svg"
},

{
 id:"world-continents",
 category:"world",
 nameKey:"worldContinentsName",
 descriptionKey:"worldContinentsDesc",
 image:"/assets/star-map-templates/world-continents.svg"
},

{
 id:"china-classic",
 category:"country",
 nameKey:"chinaClassicName",
 descriptionKey:"chinaClassicDesc",
 image:"/assets/star-map-templates/china-classic.svg"
},

{
 id:"japan-classic",
 category:"country",
 nameKey:"japanClassicName",
 descriptionKey:"japanClassicDesc",
 image:"/assets/star-map-templates/japan-classic.svg"
},

{
 id:"france-classic",
 category:"country",
 nameKey:"franceClassicName",
 descriptionKey:"franceClassicDesc",
 image:"/assets/star-map-templates/france-classic.svg"
},

{
 id:"usa-classic",
 category:"country",
 nameKey:"usaClassicName",
 descriptionKey:"usaClassicDesc",
 image:"/assets/star-map-templates/usa-classic.svg"
},

{
 id:"europe-classic",
 category:"region",
 nameKey:"europeClassicName",
 descriptionKey:"europeClassicDesc",
 image:"/assets/star-map-templates/europe-classic.svg"
},

{
 id:"east-asia",
 category:"region",
 nameKey:"eastAsiaName",
 descriptionKey:"eastAsiaDesc",
 image:"/assets/star-map-templates/east-asia.svg"
},

{
 id:"southeast-asia",
 category:"region",
 nameKey:"southEastAsiaName",
 descriptionKey:"southEastAsiaDesc",
 image:"/assets/star-map-templates/southeast-asia.svg"
},

{
 id:"china-regions",
 category:"region",
 nameKey:"chinaRegionName",
 descriptionKey:"chinaRegionDesc",
 image:"/assets/star-map-templates/china-regions.svg"
}

]);

export function getTemplatesByCategory(category) {
  return STAR_MAP_TEMPLATES.filter(
    (template) => template.category === category
  );
}
